import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";

const FILTERS = ["All", "Submitted", "In Review", "Quoted", "Paid", "Closed"];

export default function AdminRequests() {
  const [requests, setRequests] = useState([]);
  const [filter, setFilter] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/requests").then((r) => setRequests(r.data)).finally(() => setLoading(false));
  }, []);

  const filtered = filter === "All" ? requests : requests.filter((r) => r.status === filter);

  return (
    <div className="max-w-6xl">
      <p className="text-coral text-xs font-bold uppercase tracking-widest mb-2">Admin Portal</p>
      <h1 className="font-serif text-4xl font-bold tracking-tight">Sourcing Requests</h1>
      <p className="text-zinc-500 mt-2 mb-6">Review and manage all client RFQs.</p>

      <div className="flex flex-wrap gap-2 mb-6">
        {FILTERS.map((f) => (
          <button key={f} onClick={() => setFilter(f)} className={`px-4 py-1.5 rounded-sm text-sm font-semibold transition ${filter === f ? "bg-ink text-white" : "bg-white border border-zinc-200 text-zinc-600 hover:border-ink"}`} data-testid={`filter-${f.replace(/\s/g, "-")}`}>
            {f}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="text-zinc-400 py-20 text-center">Loading...</div>
      ) : (
        <div className="bg-white border border-zinc-200 rounded-sm overflow-hidden" data-testid="admin-requests-table">
          <table className="w-full text-left">
            <thead>
              <tr className="border-b-2 border-zinc-900">
                <th className="py-3 px-5 text-xs font-bold uppercase tracking-wider">Request</th>
                <th className="py-3 px-5 text-xs font-bold uppercase tracking-wider">Client</th>
                <th className="py-3 px-5 text-xs font-bold uppercase tracking-wider">Quantity</th>
                <th className="py-3 px-5 text-xs font-bold uppercase tracking-wider">Status</th>
                <th className="py-3 px-5"></th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan={5} className="py-12 text-center text-zinc-400">No requests in this view.</td></tr>
              ) : filtered.map((r) => (
                <tr key={r.id} className="border-b border-zinc-100 hover:bg-zinc-50 transition" data-testid={`admin-request-row-${r.id}`}>
                  <td className="py-4 px-5">
                    <div className="font-semibold">{r.title}</div>
                    <div className="text-xs text-zinc-500">{r.category}</div>
                  </td>
                  <td className="py-4 px-5 text-sm">
                    <div>{r.client_name}</div>
                    <div className="text-xs text-zinc-500">{r.client_email}</div>
                  </td>
                  <td className="py-4 px-5 text-sm text-zinc-600">{r.quantity}</td>
                  <td className="py-4 px-5"><StatusBadge status={r.status} /></td>
                  <td className="py-4 px-5 text-right">
                    <Link to={`/admin/requests/${r.id}`} className="text-coral font-semibold text-sm inline-flex items-center gap-1 hover:gap-2 transition-all" data-testid={`manage-request-${r.id}`}>
                      Manage <ArrowRight size={15} />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
